'use client';

var HRINSIDER_ATTACH_RESUME_LINK = 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html';
var LIMIT_CHARACTERS = 5000;
var DEFAULT_ALLOW_EXT = ['.doc', '.docx', '.pdf'];
var MAX_NUMBER_OF_CV = 3;
var IS_REQUIRED_COVER_LETTER = 1;
var IS_RESUME_ATTACHMENT = 1;
var HTTP_CODE_SUCCESS = 200;

export { DEFAULT_ALLOW_EXT, HRINSIDER_ATTACH_RESUME_LINK, HTTP_CODE_SUCCESS, IS_REQUIRED_COVER_LETTER, IS_RESUME_ATTACHMENT, LIMIT_CHARACTERS, MAX_NUMBER_OF_CV };
//# sourceMappingURL=const.js.map
